import React, { useCallback, useState } from "react";

import { useProfile } from "app/context";
import { useNotificationReceivedListener } from "app/hooks";
import { t } from "app/utils";

import ConfirmedModal from "components/event/modals/ConfirmedModal";
import notificationsTypes from "constants/notificationsTypes";

import NotificationPopup from "./notifications/NotificationPopup";
import {
  MainNotificationContainer,
  PointNotificationContainer
} from "./notifications/NotificationContainer";

const Notification = ({ notification, onClose }) => {
  const { notificationType } = notification;

  if (notificationType === "event_confirmed") {
    return <ConfirmedModal notification={notification} onClose={onClose} />;
  }
  return <NotificationPopup notification={notification} onClose={onClose} />;
};

const Notifications = () => {
  const { profile } = useProfile();

  const [notifications, setNotifications] = useState([]);
  const [pointNotifications, setPointNotifications] = useState([]);

  useNotificationReceivedListener(
    useCallback(
      notification => {
        if (
          notification.notificationType === "event_confirmed"
          && notification.entity.event.host.id === profile.id
        ) {
          return;
        }

        switch (notification.notificationType) {
          case "points_incremented":
            setPointNotifications(current => [...current, notification]);
            break;
          case notificationsTypes.PRIVATE_EVENT:
          case notificationsTypes.FOR_YOU:
          case notificationsTypes.NOT_FOR_YOU:
          case notificationsTypes.PREVIEW_MONTAGE_ERROR:
          case notificationsTypes.PREVIEW_MONTAGE_DONE:
          case notificationsTypes.TRIM_VIDEO_ERROR:
          case notificationsTypes.TRIM_VIDEO_DONE:
          case notificationsTypes.TRANSCRIPTION_ERROR:
          case notificationsTypes.TRANSCRIPTION_DONE:
          case notificationsTypes.CLUBS_ALIGNED:
          case notificationsTypes.PROGRAMS_ALIGNED:
          case notificationsTypes.CHANGE_TENANT:
            // Do not do anything because we just need to show the new user activity
            // for specific users
            return;
          default:
            setNotifications(current => [...current, notification]);
            break;
        }
      },
      [profile.id, setNotifications, setPointNotifications]
    )
  );

  const onUnseenCountChange = count => {
    const unread = count > 0 ? `(${count}) ` : "";
    document.title = unread + t("CultureHQ");
  };

  const onNotificationsSeen = () => setNotifications([]);
  const onPointNotificationSeen = () => setPointNotifications([]);

  return (
    <>
      <MainNotificationContainer
        onNewNotificationsSeen={onNotificationsSeen}
        newNotifications={notifications}
        onUnseenCountChange={onUnseenCountChange}
      />
      {profile.organization.gamificationEnabled && (
        <PointNotificationContainer
          onNewNotificationsSeen={onPointNotificationSeen}
          newNotifications={pointNotifications}
        />
      )}
    </>
  );
};

export default Notifications;
